import React from 'react'
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderTextArea, required} from '../../util/inputs'
import deixarReservasEmAberto from '../../actions/reserva/deixarReservasEmAberto';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalConfirmacaoReservaEmAberto extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoReservasEmAberto').modal('hide');
    $('#modalConfirmacaoReservasEmAberto').hide();
    $('.modal-backdrop').hide();
  }

  submit (values) {
    this.props.deixarReservasEmAberto(this.props.empresaSelecionada.id, values.observacao, this.props.reservas.filter(f => f.selecionada)
      .map(it => it.id))
      .then(() => {
          showSuccessMsg('Reservas estão em aberto');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  exibirReservas () {
    return (
      <div className="vx-modal-reservas">
        <p className="vx-modal-reservas-label">Reservas selecionadas</p>
        <ul className="vx-modal-reservas-list">
          {this.props.reservas.filter(f => f.selecionada).map(reserva => (
            <li key={reserva.id} className="vx-modal-reservas-item">
              <span className="material-icons">arrow_forward</span>
              <div>
                <div className="vx-modal-reservas-route">{reserva.descCidadeOrigem} → {reserva.descCidadeDestino}</div>
                <div className="vx-modal-reservas-pax">{reserva.passageiroDto.nome}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  render () {
    const { handleSubmit, submitting, invalid, pristine } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoReservasEmAberto" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoReservasEmAberto" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">lock_open</span>
                Deixar em Aberto
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar">
                <span className="material-icons">close</span>
              </button>
            </div>

            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="vx-modal-body">
                {this.props.reservas && this.props.reservas.filter(f => f.selecionada) ?
                  <React.Fragment>
                    {this.exibirReservas()}
                    <p className="vx-modal-obs-label">Motivo da alteração</p>
                    <Field name='observacao' css="form-control" component={renderTextArea}
                           validate={[required]} className="form-control" label=""/>
                  </React.Fragment>
                : ''}
              </div>
              <div className="vx-modal-footer">
                <button id='cancelar' type="button" className="vx-modal-btn-fechar" data-dismiss="modal">
                  Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="vx-modal-btn-confirmar" style={{background: '#f59e0b'}}>
                  <span className="material-icons" style={{fontSize: '16px'}}>check_circle</span>
                  Sim, deixar aberto
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    reservas: state.remarcacao.reservas,
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps, {
  deixarReservasEmAberto
})(reduxForm({
  form: 'formularioReservaEmAberto',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoReservaEmAberto));
